export default __webpack_public_path__ + "static/media/card-lessons.1c2640a7.png";